import { combineReducers } from 'redux';

import authReducer from './auth';
import userReducer from './users';
import workerReducer from './workers';
import repeaterReducer from './repeaters';
import detectorReducer from './detectors';
import detectorEventReducer from './detectorEvents';
import communicatorReducer from './communicators';
import organizationReducer from './organizations';
import applicationReducer from './applications';
import gatewayReducer from './gateways';
import messageReducer from './messages';
import messageMacroReducer from './messageMacros';
import noticeReducer from './notices';
import noticeMacroReducer from './noticeMacros';
import eventReducer from './events';
import dashboardReducer from './dashboard';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  worker: workerReducer,
  repeater: repeaterReducer,
  detector: detectorReducer,
  detectorEvent: detectorEventReducer,
  communicator: communicatorReducer,
  org: organizationReducer,
  application: applicationReducer,
  gateway: gatewayReducer,
  message: messageReducer,
  messageMacro: messageMacroReducer,
  notice: noticeReducer,
  noticeMacro: noticeMacroReducer,
  event: eventReducer,
  dashboard: dashboardReducer,
});
